module.exports = __webpack_public_path__ + "img/original.5a7ab8ac.svg";